import { initGlobalApps } from 'ccui-shared/legacy-dep-bootstrap/components/global-apps';

initGlobalApps({ initNonSpaAlertCenter: true });
